"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultProficiencyByCurriculum = void 0;
var DefaultProficiencyByCurriculum;
(function (DefaultProficiencyByCurriculum) {
    DefaultProficiencyByCurriculum["al"] = "onTarget";
    DefaultProficiencyByCurriculum["phdnat"] = "criteriaMet";
    DefaultProficiencyByCurriculum["phdtexas"] = "meetsExpectations";
    DefaultProficiencyByCurriculum["ww"] = "meetsExpectations";
})(DefaultProficiencyByCurriculum || (exports.DefaultProficiencyByCurriculum = DefaultProficiencyByCurriculum = {}));
